<template>
  <case-managers v-if="!isParticipantSubmission"
                 :name="field.name"
                 :id="field.name"
                 :data-vv-as="field.description.replace(/\./g, '')"
                 v-validate="{required: !field.hide && required}"
                 @input="$emit('input', $event)"
                 :value="value"
                 :disable="locked || userAccessLevel < 2"/>
  <input v-else class="form-control" type="text" disabled="disabled" :value="value"/>
</template>

<script>
import { ref, computed, getCurrentInstance } from "vue";
import CaseManagers from '@/components/search/CaseMenagers';

export default {
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    isParticipantSubmission: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input'],

  components: {CaseManagers},

  setup() {
    const root = getCurrentInstance();

    const userAccessLevel = computed(() => root.proxy.$store.getters.getUser.access)

    return {
      userAccessLevel,
    }
  }
}
</script>



// WEBPACK FOOTER //
// CaseManagerRender.vue?d29e4f2a